import type {IConcurrent, JsonDataResponse} from "~/types/types";
import {CONCURRENT_API} from "~/routes/ari_routes";
import {showErrorToast} from "~/types/helpers";
import {CONCURRENT_KEY} from "~/types/cached_keys";
import {api_header} from "~/types/api_header";
import {CONCURRENT_STATE} from "~/states/state";

export default async function() {
    const concurrents = useState<IConcurrent[]>(CONCURRENT_STATE, ()=>[])

    const {data: cached } = useNuxtData(CONCURRENT_KEY)

    if (cached.value?.data != undefined) {
        concurrents.value = cached.value.data
    } else {
        const cfg = useRuntimeConfig()

        const {data} = await
            useFetch<JsonDataResponse<IConcurrent[]>>(
                CONCURRENT_API, {
                    baseURL: String(useNuxtApp().$apiUrl()),
                    headers: api_header(),
                    key: CONCURRENT_KEY
                })

        if (data.value?.status)
            concurrents.value = data.value.data
        else
            showErrorToast(data.value?.error)
    }

    return {
        concurrents
    }
}
